import React, { useContext, useState, useRef, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import MainLayoutPage from '../Common/MainLayoutPage';
import {NavControls} from '../Common/NavControls';
import * as Constants from '../Common/CommonConstants';
import { RenderDoneDialogUnidentify } from '../Common/RenderDoneDialogUnidentify';
import UnidentifyQFormCodeEntry from './UnidentifyQFormCodeEntry';
import {QuestionnaireCodeProvider,QuestionnaireCodeContext} from './QuestionnaireCodeContext';
import { UnidentifyKeyEntryDialog, UnidentifyEntryControl } from "./UnidentifyKeyEntryDialog"
import { decodeFormId  } from '../../services/dataService';
import '../../bootoast/bootoast.css';
import bootoast from '../../bootoast/bootoast';
export default function CompCodeUnidentify(props) {

    const  questionnaireRef= useRef(null);
    const [formId, setFormId] = useState(0);
    const location = useLocation();
    // Use URLSearchParams to parse the query string
    const queryParams = new URLSearchParams(location.search);
    // Get the specific parameter (e.g., "id")
    const id = queryParams.get('fi').toString() || '';
    let validSource = false;

    //console.log("previous page URL=" + document.referrer); // Shows the previous page URL
    //console.log("origin=" + window.location.origin); // Your app's origin
    var docReferrer = document.referrer; //"https://dev.pcrb.com"; //
    if (docReferrer && (docReferrer.indexOf("pcrb.com") > -1 || docReferrer.indexOf("pcrbdata.com") > -1 || docReferrer.indexOf("dcrb.com") > -1)) {
        validSource = true;

        useEffect(() => {
            async function getFormId() {
                const decodedId = await decodeFormId(id);
                setFormId(decodedId);
            }
            getFormId();
        }, [id])
    }
    else {
        bootoast.toast({
            position: 'top',
            message: `This page came from invalid domain.`,
            type: 'danger',
            timeout: 20
        });
        console.log("This page came from invalid domain.");
    }

    return validSource && (
        <div>
            <QuestionnaireCodeProvider>
                <MainLayoutPage navControls=
                    {
                    <BuildNavControls questionnaireRef={questionnaireRef}/>
                    } 
                    contentArea=
                    {
                        <ContentArea questionnaireRef={questionnaireRef} id={formId} {...props} />
                    }>

                </MainLayoutPage>
            </QuestionnaireCodeProvider>
        </div>
    )
    
}

const BuildNavControls = (questionnaireRef) => {

    const {formState,updateFormState} = useContext(QuestionnaireCodeContext);
    
    return <NavControls questionnaireRef={questionnaireRef} formState={formState} updateFormState={updateFormState}
                                     readOnlyText="Return to enter code screen" cancelText="Cancel"  />
}


const ContentArea = ({questionnaireRef,id,...props}) => {
    //console.log("id in ContentArea=" + id);
    const { formState, stateCode, key1, key2, recipentId, qinstanceId, formData, setCompleteState, doneMessage, openAnonymousForm } = useContext(QuestionnaireCodeContext);

    if (formState === Constants.DONE_MODE)
        return ReEnterKeyMode(openAnonymousForm,doneMessage, stateCode, id,props);
    else if (formState === Constants.ENTER_KEY_MODE)
        return <UnidentifyKeyEntryDialog afterCodeConfirmationAction={openAnonymousForm} id={id} buttonText="Open Form" {...props}></UnidentifyKeyEntryDialog>

    return <UnidentifyQFormCodeEntry ref={questionnaireRef} directLoadedForm={formData} completed
        handleRefresh={() => setCompleteState()}
        readOnlyMode={(formState === Constants.READ_ONLY_MODE)}
        key1={key1}
        key2={key2} 
        recipentId={recipentId}
        qinstanceId={qinstanceId}
        {...props} />
      
}

const ReEnterKeyMode = (openAnonymousForm, doneMessage, stateCode, props)=>{

    var addOptionText =
        <div>
            or open the form again.
            <br />
            You can find your saved draft by using your Policy Number or Bureau File Number.
            <br/>
            {<UnidentifyEntryControl afterCodeConfirmationAction={openAnonymousForm} {...props} buttonText="Open Form"></UnidentifyEntryControl>}
        </div>;

    return RenderDoneDialogUnidentify(doneMessage, true, addOptionText, stateCode)
}




